import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportBasicResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportBasicInner() {
    return <PlayerLevelReportBase tab="basic" columnsSettingsViewType="PlayerLevelReportBasic" />;
}

const PlayerLevelReportBasicWithAccess = withAccessCheck(PlayerLevelReportBasicInner, playerLevelReportBasicResource);

export const PlayerLevelReportBasic = withTraceErrorBoundary(PlayerLevelReportBasicWithAccess, ErrorModal);
